module.exports = ".group-title {\n  position: absolute;\n  margin-top: -30px;\n  margin-left: 20;\n  color: #4f21b2;\n  font-weight: bolder;\n  font-size: large; }\n\n.panel {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border: none; }\n\n.form-control {\n  border: none; }\n\n.btn {\n  border-radius: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/features-livee/features.component.scss
// module id = ./src/app/modules/sessions/features-livee/features.component.scss
// module chunks = main